import { Fragment } from 'react';
import { Menu } from '@pocketlaw/tetris';
import { ThemeSelector } from 'app/domains/common-ui';
import { AccountInfoSection } from './AccountInfoSection';
import { CompanySelector } from './CompanySelector';
import { LanguageSelector } from './LanguageSelector';
export function UserAccountMenu() {
    return (<Fragment>
      <AccountInfoSection />
      <Menu.Divider />
      <CompanySelector />
      <Menu.Divider />
      <LanguageSelector />

      <ThemeSelector />
    </Fragment>);
}
